// Admin API client — /admin/auth/* (mirrors the API's auth aggregate).

import type { AdminUser } from '@a7y/types';
import { client } from './transport';

export const authApi = {
  // Auth — verify superadmin status
  getMe: () => client.get<{ user: AdminUser; isSuperAdmin: boolean }>('/auth/me'),
};
